import { render } from "./StickyNav.vue?vue&type=template&id=46e03aa4&scoped=true"
import script from "./StickyNav.vue?vue&type=script&lang=js"
export * from "./StickyNav.vue?vue&type=script&lang=js"

import "./StickyNav.vue?vue&type=style&index=0&id=46e03aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e03aa4"]])

export default __exports__